import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { LoginService } from '../../pages/login/login.service';
import { NotificationService } from '../notifications/notification.service';

/**
 * Activar/desactivar verificación en dos pasos (TOTP / Google Authenticator) desde el
 * menú de opciones del header, junto a "Cambiar Contraseña".
 *
 * El switch es un solo request de edición de usuario (LoginService.updateTwoFactor);
 * al activarlo el backend devuelve el QR ya como imagen (base64) para escanear, sin
 * paso de confirmación aparte del propio login (ahí es donde se valida el código por
 * primera vez).
 */
@Component({
  selector: 'app-two-factor',
  templateUrl: './two-factor.component.html',
  styleUrls: ['./two-factor.component.scss']
})
export class TwoFactorComponent implements OnInit {
  @Input() userId: number;
  /** Estado actual de la cuenta (viene del usuario logueado). */
  @Input() enabled: boolean = false;
  @Output() closeModal = new EventEmitter<void>();

  public step: 'intro' | 'qr' = 'intro';
  public qrImage: string | null = null;
  public secret: string | null = null;
  public loading: boolean = false;
  public error: string | null = null;

  constructor(
    private _loginService: LoginService,
    public notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.step = 'intro';
  }

  activate(): void {
    this.loading = true;
    this.error = null;

    this._loginService.updateTwoFactor({
      user_id: this.userId,
      two_factor_enabled: true
    }).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res?.res === 1 && res?.data?.qr_image) {
          this.qrImage = res.data.qr_image;
          this.secret = res.data.secret ?? null;
          this.step = 'qr';
          this.enabled = true;
        } else {
          this.error = 'No se pudo generar el código QR. Intentá de nuevo.';
        }
      },
      error: (error: HttpErrorResponse) => {
        console.error(error);
        this.loading = false;
        this.error = 'No se pudo activar la verificación en dos pasos. Intentá de nuevo.';
      }
    });
  }

  deactivate(): void {
    this.loading = true;
    this.error = null;

    this._loginService.updateTwoFactor({
      user_id: this.userId,
      two_factor_enabled: false
    }).subscribe({
      next: () => {
        this.loading = false;
        this.enabled = false;
        this.step = 'intro';
        this.qrImage = null;
        this.secret = null;
        this.notificationService.success('Verificación en dos pasos desactivada');
      },
      error: (error: HttpErrorResponse) => {
        console.error(error);
        this.loading = false;
        this.error = 'No se pudo desactivar. Intentá de nuevo.';
      }
    });
  }

  close(): void {
    this.closeModal.emit();
  }
}
